/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Deactivateaccountdescriptionv23Inputs */

const en_settings_deactivateaccountdescriptionv23 = /** @type {(inputs: Settings_Deactivateaccountdescriptionv23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To deactivate your account or general enquiries and concerns, please contact our support team at`)
};

/**
* | output |
* | --- |
* | "To deactivate your account or general enquiries and concerns, please contact our support team at" |
*
* @param {Settings_Deactivateaccountdescriptionv23Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_deactivateaccountdescriptionv23 = /** @type {((inputs?: Settings_Deactivateaccountdescriptionv23Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Deactivateaccountdescriptionv23Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_deactivateaccountdescriptionv23(inputs)
});
export { settings_deactivateaccountdescriptionv23 as "settings_deactivateAccountDescriptionV2" }